import { TRANSACTION_STATUS } from './constants'

export const parseAmount = (amount: number | string): string => {
	if (typeof amount === 'number') {
		return amount.toFixed(2)
	}
	return Number.parseFloat(amount).toFixed(2)
}

export const parseDate = (date: Date | string): string => {
	const dateObj = new Date(date)
	return dateObj.toLocaleDateString()
}

export const parseStatus = (value: string): string => {
	const translatedValue = TRANSACTION_STATUS[value]
	return translatedValue || value
}
